import '../scss/style.scss';
import './modules/assistant.js';
import './modules/gallery.js';
import './modules/faq.js';
import './modules/filters.js';
import './modules/chat-widget.js';

// Scroll to top
document.getElementById('js-scroll-to-top')?.addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

